import { Box, Flex, Text } from '@chakra-ui/react';

import {
  CustomDrawerFooter,
  PrimaryButton,
} from '../../../../components/custom';
import {
  currencyUnformat,
  formatDate,
  formatNumber,
} from '../../../../helpers/utilityFunctions';
import { IAirtimePurchaseSummary } from '../../../../types/billPayment';

interface AirtimePurchaseSummaryProps {
  summary: IAirtimePurchaseSummary;
  networkPackage: string;
  handleSubmit: () => void;
}

export default function AirtimePurchaseSummary({
  summary,
  networkPackage,
  handleSubmit,
}: AirtimePurchaseSummaryProps) {
  return (
    <>
      <Box
        borderRadius="24px"
        borderWidth="1px"
        borderColor="gray.200"
        w="full"
        marginTop={6}
      >
        <Box
          borderRadius="24px"
          backgroundColor="#001419"
          padding={{ base: '30px', md: '24px' }}
          py={4}
          mb={2}
        >
          <Text fontSize="1rem" color="#FFFFFF" lineHeight="1.5rem" mb={2}>
            Purchase Summary
          </Text>
          <Text fontSize=".875rem" color="#7B828E" lineHeight="1.5rem">
            Please confirm that the details below are correct.
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          p={'28px 24px 34px 24px'}
          gap={6}
        >
          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Network
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {summary.network}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Package
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {networkPackage}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Phone number
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {summary.phoneNumber}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Amount
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              NGN {summary.amount}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Date
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {summary.date !== undefined
                ? formatDate(summary.date.toString())
                : ''}
            </Text>
          </Flex>
        </Box>
      </Box>

      <CustomDrawerFooter direction={'column'}>
        <Flex justifyContent="space-between" ml={2} mr={4} mb={4} w={'98'}>
          <Text
            fontSize="1rem"
            lineHeight="1.5rem"
            fontWeight={500}
            color="#1A1C1F"
          >
            Total Amount
          </Text>
          <Text
            fontSize="1.5rem"
            lineHeight="1.5rem"
            fontWeight={500}
            color="#1A1C1F"
          >
            {
              formatNumber(currencyUnformat(summary.amount.toString()))
                .nairaString
            }
          </Text>
        </Flex>
        <PrimaryButton onClick={handleSubmit} w="full" paddingY={'4'}>
          Continue
        </PrimaryButton>
      </CustomDrawerFooter>
    </>
  );
}
